import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import PuzzleCard from '../components/PuzzleCard';
import { fetchJson, sitePath } from '../lib/api';

export default function CatalogPage() {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchJson(sitePath('/catalog'))
      .then((json) => {
        setTypes(json.data || []);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Header />
      <main className="mx-auto max-w-6xl px-4 py-8">
        <section className="max-w-4xl rounded-[1.75rem] border border-white/70 bg-white/80 p-6 shadow-xl shadow-slate-200/60 backdrop-blur sm:p-7">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-brand-cyan">
            Play online
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-slate-900 md:text-[2.35rem]">
            Choose a puzzle family
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-600 md:text-base">
            Start with polished online play for the puzzle types that are ready now, and preview the families that are lined up next.
          </p>
        </section>

        {loading ? <p className="mt-8 text-slate-600">Loading puzzle types…</p> : null}
        {error ? <p className="mt-8 text-rose-600">{error}</p> : null}

        <div className="mt-7 grid grid-cols-1 justify-items-center gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {types.map((type) => (
            <Link key={type.id} to={`/catalog/${type.slug}`} className="block group">
              <PuzzleCard
                puzzle={{
                  title: type.name,
                  description: type.description,
                  thumbnail: type.iconUrl,
                  status: type.status,
                  puzzleCount: type.puzzleCount,
                }}
              />
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
